import { isEmpty } from 'lodash-es'
import { useCallback } from 'react'

import { useGetBuffersQuery } from 'features/meetings/api'

export const useAncillaryMeetingData = (({ meetings, showBuffers }) => {
  const uuids = meetings.flatMap(({ events }) => events.map(({ uuid }) => uuid))
  const { data: bufferData, isLoading: buffersLoading } = useGetBuffersQuery({ uuids }, { skip: !showBuffers || isEmpty(uuids) })

  const updateWithBufferData = useCallback((currentMeetings) => {
    if (isEmpty(bufferData?.events)) return currentMeetings

    return currentMeetings.map((meeting) => {
      const updatedEvents = meeting.events.map((event) => {
        const bufferEvent = bufferData.events.find((buffer) => buffer.uuid === event.uuid)
        if (bufferEvent) {
          const updatedEventMemberships = event.eventMemberships.map((member) => {
            const matchingBuffer = bufferEvent.buffers.find(
              (buffer) => buffer.user.uuid === member.uuid
            )


            if (matchingBuffer) {
              return {
                ...member,
                id: matchingBuffer.id,
                hasBeforeBuffer: matchingBuffer.hasBeforeBuffer,
                hasAfterBuffer: matchingBuffer.hasAfterBuffer,
                beforeBufferTime: matchingBuffer.beforeBufferTime,
                afterBufferTime: matchingBuffer.afterBufferTime
              }
            }
            return member
          })

          return {
            ...event,
            eventMemberships: updatedEventMemberships
          }
        }
        return event
      })
      return { ...meeting, events: updatedEvents }
    })
  }, [bufferData])

  const updateWithAncillaryData = useCallback((updatedMeetings) => updateWithBufferData(updatedMeetings),
    [updateWithBufferData])

  return [
    updateWithAncillaryData,
    { isLoading: buffersLoading }
  ]
})
